import { get } from "lodash";

const styles = ({ color, fontSize }) => ({
  normalKey: {
    '&:before': {
      backgroundColor: get(color, 'success'),
    },
  },
  startReportingKey: {
    '&:before': {
      backgroundColor: get(color, 'warning'),
    },
  },
  urgentReportingKey: {
    '&:before': {
      backgroundColor: get(color, 'error'),
    },
  },
  deleteLink: {
    color: get(color, 'error'),
    cursor: 'pointer',
  },
  cancelLink: {
    color: get(color, 'primaryButtonBackground'),
    cursor: 'pointer',
    marginLeft: 10,
  },
  noTitleGrid: {
    marginTop: 20,
    display: 'flex',
  },
  addBtn: {
    float: 'right',
    marginTop: 30,
    minWidth: 140,
  },
  paperClass: {
    padding: 32,
    paddingTop: 0,
    maxHeight: 'calc(100% - 125px)',
    maxWidth: 750,
  },
  status: {
    position: 'relative',
    display: 'inline-block',
    paddingLeft: '15px',
    verticalAlign: 'middle',
    letterSpacing: 0,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      content: '""',
      left: 0,
      top: '50%',
      marginTop: '-6px',
      height: '10px',
      width: '10px',
      borderRadius: '10px',
    },
  },
});

export default styles;